import { TeamMember, Volunteer } from "../types/team";
import { colors } from "../styles/theme";

export const administration: (administration & { status?: "green" | "red" })[] = [
  {
    name: "Emmanuel MILLIOT",
    role: "Président",
    image: "https://cdn.francestudent.org/images/team/emmanuel.jpeg",
    linkedin: "https://www.linkedin.com/in/emmanuelmilliot/",
    instagram: "https://instagram.com/emmanuelmilliot/",
    mail: "mailto:emmanuel@ffs.contact",
    color: colors.primary,
    status: "green",
  },
  {
    name: "Logan VINH-SAN",
    role: "Vice-Président",
    image: "https://cdn.francestudent.org/images/team/logan.jpeg",
    linkedin: "https://www.linkedin.com/in/logan-vinh-san-09b530225/",
    instagram: "https://instagram.com/logan.vhsn/",
    mail: "mailto:logan@ffs.contact",
    color: colors.primary,
    status: "green",
  },
  ,
  {
    name: "Louca SILVANT",
    role: "Administrateur",
    image: "https://cdn.francestudent.org/images/team/loucas.png",
    color: colors.primary,
    mail: "mailto:louca@ffs.contact",
    instagram: "https://www.instagram.com/lekkerelou/",
    linkedin: "https://www.linkedin.com/in/louca-silvant/",
    status: "green",
  },
];

export const communication: (communication & { status?: "green" | "red" })[] = [
];

export const developpement: (developpement & { status?: "green" | "red" })[] = [
    {
        name: "Cameron B.",
        role: "Développeur",
        image: "https://cdn.francestudent.org/images/team/cameron_b.png",
        color: colors.primary,
        status: "green",
    },
    {
        name: "Nathanaël M.",
        role: "Dev. Mobile",
        image: "https://cdn.francestudent.org/images/team/nathanael.png",
        color: colors.primary,
        status: "green",
    },
    {
        name: "Maxime D.",
        role: "Développeur",
        image: "https://cdn.francestudent.org/images/team/maxime_d.png",
        color: colors.primary,
        status: "green",
    }
];
